import qs from 'qs';
import { stringifyDateReverse, parseDateString } from '@ott/utility-date';

export function getSearchRoute({
  departure,
  arrival,
  date,
  returnDate,
  passengersValues = {},
  vk,
  returnWay,
  ow,
}) {
  if (!(date instanceof Date)) {
    // eslint-disable-next-line no-param-reassign
    date = parseDateString(date);
  }

  if (returnDate && !(returnDate instanceof Date)) {
    // eslint-disable-next-line no-param-reassign
    returnDate = parseDateString(returnDate);
  }

  const searchParams = {
    date: stringifyDateReverse(date),
    ...passengersValues,
    vk,
    // если убрать данный параметр,
    // то при перезагрузке страницы пользователь попадет на CEO страницу
    s: true,
  };

  if (returnWay) {
    searchParams.returnWay = true;
  }

  if (ow) {
    searchParams.ow = true;
  }

  if (date && returnDate) {
    searchParams.returnDate = stringifyDateReverse(returnDate);
  }

  const search = qs.stringify(searchParams, { addQueryPrefix: true });
  const pathname = `/${departure}_${arrival}/`;

  return `${pathname}${search}`;
}
